export default {
    zh:{
        createQuotationApplySuccess:'产品报价申请单创建成功',
    },
    en:{
        createQuotationApplySuccess:'Create product quotation apply success',
    }
}
